'use strict';
var React = require('react');
module.exports = function () {
    return this.props.signedIn ? React.createElement('div', {
        'className': 'author-image-container',
        'key': '0'
    }, React.createElement('img', {
        'className': this.props.signedIn ? 'author-image logged-in-author' : 'author-image',
        'src': this.props.authorInfo && this.props.authorInfo.avatar || this.props.authorImage
    })) : null;
};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/commenting_widget/author_profile.rt
// module id = 379
// module chunks = 6 7